export const environment = {
  production: false,
  apiUrl: 'https://seve-preprod.azurewebsites.net/api',
  baseUrl: 'https://seve-preprod.azurewebsites.net/',
  websiteUrl: 'https://preprod.seve-tp.com/',
  fntpPortalUrl: 'https://fntp-adherents-git-preprod-marketing-dev-webexp-r.vercel.app',
  adminMail: 'seve@seve-tp.com'
};
